import { api } from '../../../../stores/api';
import { Api } from '@automapa/svelte-automapa-template';
import { LocationApi, type JobHistoryEventResponseType } from '../LocationApi';
import { JobHistoryItem } from './JobHistoryItem';
import { get } from 'svelte/store';
import jsonExample from './Mock/jobHistoryRejectConfirm.json';
import { JobHistoryImporter } from './JobHistoryImporter';
import { TacticalPlanRule } from '../../_deprecated_components/TacticalPlan/TacticalPlanRule';
import { TacticalPlanRuleApi } from '../../_deprecated_components/TacticalPlan/TacticalPlanRuleApi';
import { JobHistoryVisibility } from './JobHistoryVisibility';
// import { type ZoneType } from '../../Zones/types';
// import { ZoneApi } from '../../Zones/ZoneApi';

export class JobHistoryApp {
    private api: Api = get(api);
    public jobHistoryList: JobHistoryItem[] = [];
    public tacticalPlanRules: TacticalPlanRule[] = [];
    // public mapZones: ZoneType[] = []; // DEPRECATED

    async load(jobId: number) {
        let tacticalPlanRulesResponse = await TacticalPlanRuleApi.getAll(this.api);
        this.tacticalPlanRules = tacticalPlanRulesResponse.map(
            rule => new TacticalPlanRule(rule, false)
        );
        // let mapZonesResponse = await ZoneApi.getAll(this.api);
        // if (mapZonesResponse) {
        //     this.mapZones = mapZonesResponse;
        // }
        // console.log('JobHistoryApp, load, mapZones', this.mapZones);

        let jobHistoryResponse = await LocationApi.getHistory(this.api, jobId);
        this.set(jobHistoryResponse);
        // // --- load example data ---
        // // let jobHistoryResponse = z.array(JobHistoryEventResponseSchema).parse(jsonExample);
        // jobHistoryResponse.sort((a, b) => {
        //     // return new Date(a.event_time).getTime() - new Date(b.event_time).getTime();
        //     return a.event_id - b.event_id;
        // });
        // this.jobHistoryList = JobHistoryImporter.convert(jobHistoryResponse);
        // this.jobHistoryList = JobHistoryVisibility.setVisibilities(this.jobHistoryList);
    }

    set(jobHistoryResponse: JobHistoryEventResponseType[]) {
        jobHistoryResponse.sort((a, b) => {
            // return new Date(a.event_time).getTime() - new Date(b.event_time).getTime();
            return a.event_id - b.event_id;
        });
        this.jobHistoryList = JobHistoryImporter.convert(jobHistoryResponse);
        this.jobHistoryList = JobHistoryVisibility.setVisibilities(this.jobHistoryList);
    }

    getJobHistoryList() {
        return this.jobHistoryList;
    }

    getJobHistoryListVisible(max: number | null = null, onlyVisible: boolean = true) {
        if (!onlyVisible) {
            return max === null ? this.jobHistoryList : this.jobHistoryList.slice(-max);
        }
        return max === null
            ? this.jobHistoryList.filter(item => item.isVisible())
            : this.jobHistoryList.filter(item => item.isVisible()).slice(-max);
    }
}
